import {Component, ElementRef, Input, OnChanges, OnInit, ViewChild, SimpleChanges, EventEmitter, Output} from "@angular/core";
import {CalendarConfig} from "./calendar-config";
import {CalendarViewComponent} from "./calendar-view/calendar-view.component";
import {DateInputComponent} from "./date-input/date-input.component";
import {formatDate} from "./calendar-view/calendar-tools";

@Component({
    selector: 'sara-datepicker-range',
    templateUrl: './datepicker-range.component.html'
})
export class DatePickerRangeComponent implements OnInit, OnChanges {
    public elementRef;

    @Input() position;
    @Input() format;
    @Input() disableDates;
    @Input() locale;
    @Input() period: Period;
    @Input() errors?: any;

    @Input() fromPlaceholder: string = "from";
    @Input() toPlaceholder: string = "to";

    // date-input
    startElement: string;
    endElement: string;

    private selectedDateFrom: Date;
    private selectedDateTo: Date;

    @ViewChild("fromCalendar") fromCalendar: CalendarViewComponent;
    @ViewChild("toCalendar") toCalendar: CalendarViewComponent;

    @ViewChild("fromDateInput") fromDateInput: DateInputComponent;
    @ViewChild("toDateInput") toDateInput: DateInputComponent;

    @Output() periodUpdated = new EventEmitter();

    constructor(myElement: ElementRef, private config: CalendarConfig) {
        this.elementRef = myElement;
        this.position = config.position;
        this.format = config.format;
        this.disableDates = config.disableDates;
        this.locale = config.locale;
        this.period = {
            from: null,
            to: null
        };
    }

    ngOnInit() {
        this.startElement = "start";
        this.endElement = "end";
        if(!!this.period) {
            this.selectedDateFrom = this.period.from;
            this.selectedDateTo = this.period.to;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // workaround for modal
        if(!!this.period) {
            this.selectedDateFrom = this.period.from;
            this.selectedDateTo = this.period.to;
        }
    }

    private openCalendarStart: boolean;
    private openCalendarEnd: boolean;


    fromDateSelected(selected) {
        if(!!this.period) {
            this.period.from = selected.selected;
        }
        this.selectedDateFrom = selected.selected;
        this.fromCalendar.hide();
        !!this.selectedDateTo ? this.toCalendar.hide(): this.showCalendar(this.toCalendar, this.toDateInput);
        this.periodUpdated.emit({field: "from", period : this.period});
    }

    toDateSelected(selected) {
        this.selectedDateTo = selected.selected;
        if(!!this.period) {
            this.period.to = selected.selected;
        }
        this.toCalendar.hide();
        !!this.selectedDateFrom ? this.fromCalendar.hide(): this.showCalendar(this.fromCalendar, this.fromDateInput);
        this.periodUpdated.emit({field: "to", period : this.period});
    }

    private showCalendar(calendar:CalendarViewComponent, dateInput: DateInputComponent) {
        dateInput.focus();
        calendar.show();
    }

    isFromCalendarOpen() : boolean {
        return this.openCalendarStart;
    }

    isToCalendarOpen() : boolean {
        return this.openCalendarEnd;
    }

    handleClickInputFrom() {
        this.toCalendar.hide();
        this.fromCalendar.toggle();
    }

    handleClickInputTo() {
        this.fromCalendar.hide();
        this.toCalendar.toggle();
    }

    private timeOutIdFrom : number;
    private keepOpenFrom : boolean = false;

    private timeOutIdTo : number;
    private keepOpenTo : boolean = false;

    hideFromCalendar() {
        if(this.timeOutIdFrom !== null) {
            clearTimeout(this.timeOutIdFrom);
            this.timeOutIdFrom = null;
        }
        if(!this.keepOpenFrom) {
            this.timeOutIdFrom = setTimeout(() => {
               this.fromCalendar.hide();
               this.timeOutIdFrom = null
            });
        }
        this.keepOpenFrom = false;
    }

    hideToCalendar() {
        if(this.timeOutIdTo !== null) {
            clearTimeout(this.timeOutIdTo);
            this.timeOutIdTo = null;
        }
        if(!this.keepOpenTo) {
            this.timeOutIdTo = setTimeout(() => {
                this.toCalendar.hide();
                this.timeOutIdTo = null
            });
        }
        this.keepOpenTo = false;
    }

    preventCloseFrom() {
        this.keepOpenFrom = true;
        if(this.timeOutIdFrom !== null) {
            clearTimeout(this.timeOutIdFrom);
            this.timeOutIdFrom = null;
        }
        // workaround to set focus on the input while clicking on calendar but not selecting date.
        setTimeout(()=> this.fromDateInput.focus());
    }

    preventCloseTo() {
        this.keepOpenTo = true;
        if(this.timeOutIdTo !== null) {
            clearTimeout(this.timeOutIdTo);
            this.timeOutIdTo = null;
        }
        // workaround to set focus on the input while clicking on calendar but not selecting date.
        setTimeout(()=> this.toDateInput.focus());
    }

    fromDateAsString(): string {
        return !!this.selectedDateFrom ? formatDate(this.selectedDateFrom, this.format, this.locale) : "";
    }

    toDateAsString(): string {
        return !!this.selectedDateTo? formatDate(this.selectedDateTo, this.format, this.locale) : "";
    }
}

interface Period {
    from: Date;
    to: Date;
}


// WEBPACK FOOTER //
// ./public/upgrade/core/datepicker/datepicker-range.component.ts